import BoltIcon from '@mui/icons-material/Bolt';
import GroupsIcon from '@mui/icons-material/Groups';
import NatureIcon from '@mui/icons-material/Nature';
import { Box, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import ScorePropTypes from '../../proptypes/score';
import {
    computeDisplayableCo2g,
    computeDisplayableCo2gPerMin,
    computeDisplayableCo2gWithUnit,
} from '../../services/computation/computeDisplayableCo2g';
import { computeMilliWh } from '../../services/computation/computeMilliWh';
import CompareScoreChip from './CompareScoreChip';
import TypographyWithIcon from './TypographyWithIcon';

const TotalScoreConsumption = ({
    score,
    scoreReference,
    variant,
    iconFontSize,
    executionCount,
}) => (
    <Box>
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
                gap: 2,
            }}
        >
            <TypographyWithIcon
                icon={
                    <Tooltip
                        title="Estimated consumption"
                        aria-label="Estimated consumption"
                    >
                        <NatureIcon fontSize={iconFontSize} />
                    </Tooltip>
                }
                variant={variant}
            >
                {computeDisplayableCo2g(score?.co2?.total)} mg eq. CO<sub>2</sub>
            </TypographyWithIcon>
            <Typography>({computeDisplayableCo2gPerMin(score)} mg/min)</Typography>
            <CompareScoreChip
                score={score?.co2?.total}
                scoreReference={scoreReference?.co2?.total}
            />
        </Box>
        <TypographyWithIcon
            icon={
                <Tooltip title="Electric consumption" aria-label="Electric consumption">
                    <BoltIcon fontSize="12px" />
                </Tooltip>
            }
            variant="body"
        >
            {computeMilliWh(score?.wh?.total)} mWh
        </TypographyWithIcon>
        {executionCount && (
            <TypographyWithIcon
                icon={
                    <Tooltip
                        title="Estimated consumption by estimated visit"
                        aria-label="Estimated consumption by estimated visit"
                    >
                        <GroupsIcon fontSize="12px" />
                    </Tooltip>
                }
                variant="body"
            >
                {computeDisplayableCo2gWithUnit(score?.co2?.total, executionCount)}
                eq. CO<sub>2</sub> - Estimated visit: {executionCount}
            </TypographyWithIcon>
        )}
    </Box>
);

TotalScoreConsumption.propTypes = {
    score: ScorePropTypes.isRequired,
    whReference: ScorePropTypes,
    variant: PropTypes.string,
    iconFontSize: PropTypes.string,
    scoreReference: ScorePropTypes,
    executionCount: PropTypes.number,
};

TotalScoreConsumption.defaultProps = {
    variant: 'h5',
    iconFontSize: 'default',
};

export default TotalScoreConsumption;
